<template>
  <div class="form-group">
    <label class="form-control-label">
      {{ label }}
    </label>
    <div class="row">
      <div class="col-4">
        <select v-model="month" name="month" class="form-control" >
          <option value="">Month</option>
          <option v-for="index in 12" :key="index" :value="`${index <= 9 ? 0 : ''}${index}`">{{ ("00" + index).slice(-2) }}</option>
        </select>
      </div>
      <div class="col-4">
        <select v-model="day" name="day" class="form-control" >
          <option value="">Day</option>
          <option v-for="index in 31" :key="index" :value="`${index <= 9 ? 0 : ''}${index}`">{{ ("00" + index).slice(-2) }}</option>
        </select>
      </div>
      <div class="col-4">
        <select v-model="year" name="year" class="form-control" >
          <option value="">Year</option>
          <option v-for="yearOption in yearRange" :key="yearOption" :value="yearOption">{{ yearOption }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: {
    value: {
      required: false,
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: 'Date'
    },
    startYear: {
      type: Number,
      default: 1920
    },
    endYear: {
      type: Number,
      default: () => new Date().getFullYear()
    }
  },

  data() {
    return {
      tempMonth: "",
      tempDay: "",
      tempYear: "",
    }
  },

  computed: {
    yearRange() {
      const years = []
      for (let year = this.endYear; year >= this.startYear; year--) {
        years.push(year)
      }
      return years
    },

    month: {
      get() {
        if (!this.value) return this.tempMonth;

        return moment(this.value).format('MM')
      },
      set(newValue) {
        this.tempMonth = newValue
        if (newValue !== "" && this.day !== "" && this.year !== "") {
          this.$emit('input', `${this.year}-${newValue}-${this.day}`)
        }
      },
    },
    day: {
      get() {
        if (!this.value) return this.tempDay;

        return moment(this.value).format('DD')
      },
      set(newValue) {
        this.tempDay = newValue
        if (newValue !== "" && this.month !== "" && this.year !== "") {
          this.$emit('input', `${this.year}-${this.month}-${newValue}`)
        }
      },
    },
    year: {
      get() {
        if (!this.value) return this.tempYear;

        return moment(this.value).format('YYYY')
      },
      set(newValue) {
        this.tempYear = newValue
        if (newValue !== "" && this.month !== "" && this.day !== "") {
          this.$emit('input', `${newValue}-${this.month}-${this.day}`)
        }
      },
    },
  },
}
</script>
